/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        this.currentQuantities[item.dataset.variantId] = Number(item.querySelector('.qty-input__input').value);
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const removeButton = evt.target.closest('.js-remove-item');
      if (!removeButton) return;
      evt.preventDefault();
      const updateProperties = this.updateProperties.bind(this);

      if(removeButton.getAttribute('data-type') === 'remove-engraving') {
        const isEngraving = removeButton.closest('.cart-item[data-engraving-id]');
        const isGiftWrap = removeButton.closest('.cart-item[data-gift-wrap-id]');
        const isWarranty = removeButton.closest('.cart-item[data-warranty-id]');
        
        if (isEngraving || isGiftWrap || isWarranty) {
          // Identify the correct hash based on what is being removed
          let currentHash;
          if (isEngraving) currentHash = isEngraving.getAttribute('data-engraving-id');
          else if (isGiftWrap) currentHash = isGiftWrap.getAttribute('data-gift-wrap-id');
          else if (isWarranty) currentHash = isWarranty.getAttribute('data-warranty-id');

          const mainItem = document.querySelector(`.cart-items [data-engraving-pid="${currentHash}"]`);

          if (!mainItem) {
            this.updateQuantity(removeButton.dataset.index, 0, '');
            return;
          }

          let propertiesToUpdate = {};

          if (isEngraving) {
            const correspondingGiftWrapEl = document.querySelector(`.cart-items [data-gift-wrap-id="${currentHash}"]`);
            const correspondingWarrantyEl = document.querySelector(`.cart-items [data-warranty-id="${currentHash}"]`);

            propertiesToUpdate = {
              "_Engraving Font": null,
              _mapped_engraving_text: null,
              id_of_variant_with_engraving: null,
              _hash: null
            };

            // FIX: If a gift wrap OR a warranty still exists, keep the hash alive on the main product so they don't break!
            if (correspondingGiftWrapEl || correspondingWarrantyEl) {
              propertiesToUpdate["_hash"] = currentHash;
            }
          } else if (isGiftWrap) {
            const correspondingEngravingEl = document.querySelector(`.cart-items [data-engraving-id="${currentHash}"]`);
            const correspondingWarrantyEl = document.querySelector(`.cart-items [data-warranty-id="${currentHash}"]`);

            propertiesToUpdate = {
              _hash: null
            };

            // Maintain hash if engraving or warranty still exists
            if (correspondingEngravingEl || correspondingWarrantyEl) {
              propertiesToUpdate["_hash"] = currentHash;
              // If only engraving is left (or engraving + warranty), we just remove the gift wrap
              this.updateQuantity(removeButton.dataset.index, 0, '');
              return; 
            }
          } else if (isWarranty) {
             const correspondingEngravingEl = document.querySelector(`.cart-items [data-engraving-id="${currentHash}"]`);
             const correspondingGiftWrapEl = document.querySelector(`.cart-items [data-gift-wrap-id="${currentHash}"]`);
             
             propertiesToUpdate = {
              _hash: null
            };
            
            // Maintain hash if engraving or gift wrap still exists
            if (correspondingEngravingEl || correspondingGiftWrapEl) {
              propertiesToUpdate["_hash"] = currentHash;
              this.updateQuantity(removeButton.dataset.index, 0, '');
              return;
            }
          }

          updateProperties(mainItem, propertiesToUpdate).then(() => {  
            this.updateQuantity(removeButton.dataset.index, 0, '');
          });
        } else {
          this.updateQuantity(removeButton.dataset.index, 0);
        }
      } else {
        this.updateQuantity(removeButton.dataset.index, 0);
      }
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      const updates = {};
      const rowToUpdateEl = document.getElementById(`cart-item-${line}`);

      if (rowToUpdateEl) {
        // 1. Check if the item being clicked is the MAIN product
        const isMainProduct = rowToUpdateEl.hasAttribute('data-engraving-pid');
        const bundleId = rowToUpdateEl.getAttribute('data-engraving-pid');

        if (isMainProduct && bundleId) {
          // 2. If it IS the main product, group everything together and update/delete them all at once
          // FIX: Added warranty ID query to the bundle delete logic
          const relatedItems = document.querySelectorAll(`
            .cart-item[data-engraving-pid="${bundleId}"],
            .cart-item[data-engraving-id="${bundleId}"],
            .cart-item[data-gift-wrap-id="${bundleId}"],
            .cart-item[data-warranty-id="${bundleId}"]
          `);

          relatedItems.forEach(itemEl => {
            const key = itemEl.getAttribute('data-key');
            if (key) updates[key] = quantity;
          });
        } else {
          // 3. If it is JUST the engraving being removed, OR a normal un-engraved product, only update itself
          const key = rowToUpdateEl.getAttribute('data-key');
          if (key) updates[key] = quantity;
        }
      }
      
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        updates,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartSummary = document.getElementById('cart-summary');
          if (cartSummary) cartSummary.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          if (lineErrors) lineErrors.textContent = theme.strings.cartError;
        } else {
          if (lineErrors) lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        if (input) {
           input.value = input.dataset.initialValue;
           input.closest('quantity-input').currentQty = input.dataset.initialValue;
        }
      } finally {
        this.classList.remove('pointer-events-none');

        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }

    /**
     * Removes engraving properties from a cart item.
     * @param {HTMLElement} lineItem - The cart item element to remove engraving properties from.
     * @returns {Promise} - Promise that resolves with the cart update response.
     */
    async updateProperties(lineItem, propertiesToUpdate = {}) {
      const body = {
        id: lineItem.dataset.key,
        properties: propertiesToUpdate
      };
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      return response.json();
    }
  }

  customElements.define('cart-items', CartItems);
}